// extracted by mini-css-extract-plugin
export default {"tenantName":"tenant-action-modal_tenantName__QQosK","pkiButtonPrimary":"tenant-action-modal_pkiButtonPrimary__xrmbN"};